import { Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React from 'react';

export default function FieldIdCommon({ fieldId }) {
    if (!fieldId.includes('field_')) {
        return null;
    }

    return (
        <div className="lstCreateForm lstCreateForm--changePt">
            <span style={{ fontWeight: '400', color: '#2E3138' }}>
                {I18n.get('CM-LABEL-FIELD-ID')}
            </span>{' '}
            :
            <Tooltip title={fieldId} arrow placement="top">
                <span
                    className="id-detail-ticket-copy"
                    onClick={async () => {
                        navigator.clipboard
                            .writeText(fieldId)
                            .then(() => {})
                            .catch(err => {});
                    }}
                >
                    <img src="/assets/image/icon-copy.svg" alt="" />
                </span>
            </Tooltip>
            <span>{fieldId}</span>
        </div>
    );
}
